import React, { cloneElement } from 'react';
import { Heading, useBreakpoint, Group, Skeleton } from '@landr/maestro';
import * as Styled from './Title.styled';

const HeadingItem: React.FC = ({ children }) => {
    const isMobile = useBreakpoint('md');

    return (
        <Group.Item>
            <Heading as={'h1'} size={isMobile ? 'xxl' : 'jb'} mb={0}>
                {children}
            </Heading>
        </Group.Item>
    );
};

const AsteriskItem = ({ children }: { children: React.ReactNode }) => {
    return (
        <Group.Item>
            <Styled.AsteriskWrapper>{children}</Styled.AsteriskWrapper>
        </Group.Item>
    );
};

const TitleSkeleton = () => {
    return (
        <Styled.TitleSkeletonWrapper>
            <Skeleton />
        </Styled.TitleSkeletonWrapper>
    );
};

const Title = ({
    isLoading,
    title,
    icon,
}: {
    isLoading: boolean;
    title: string;
    icon?: JSX.Element;
}) => {
    if (isLoading) {
        return <TitleSkeleton />;
    }

    return (
        <Group
            alignItems="center"
            gutter={0}
            maxWidth="768px"
            minHeight={'48px'}
        >
            {icon && <AsteriskItem>{cloneElement(icon)}</AsteriskItem>}
            <HeadingItem>{title}</HeadingItem>
        </Group>
    );
};

export default Title;
